import React from "react"
import { SvgIcon, SvgIconProps } from "@mui/material"

const addSectiionIconSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28"><path fill="currentColor" d="M4 10h5V9H4v1zM11 10h6V9h-6v1zM24 10h-5V9h5v1zM6.5 14c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-15zM6 15.5c0-.28.22-.5.5-.5h15c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-3z"></path></svg>
)

const AddSectionIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {addSectiionIconSvg}
    </SvgIcon>
)

export default AddSectionIcon